
import { Component, Mixins } from "vue-property-decorator";
import {
  IDrawableItem,
  ITextDrawable,
  instanceOfITextDrawable,
  instanceOfIHeightAutoAdjustable,
} from "../../../../../domain/document/items";
import { TextStyle, FontSizeCalculator } from "../../../../../domain/drawing";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";

@Component({
})
export default class TextDrawerPropertyEditableMixin extends Mixins() implements IDrawableItemEditable {
  editingSource: IDrawableItem;
  writeProperty: (write: (source: ITextDrawable) => void) => void;

  get textStyle(): TextStyle {
    return instanceOfITextDrawable(this.editingSource)
      ? this.editingSource.textStyle
      : undefined;
  }

  set textStyle(value: TextStyle) {
    this.writeProperty(s => {
      s.textStyle = value;
      if (instanceOfIHeightAutoAdjustable(s) && s.shouldAutoAdjustHeight) {
        s.geometry.rectangle.size.height = FontSizeCalculator.calculateObjectHeight(s);
      }
    });
  }
}
